import axios from "axios";

class TrustpilotReviews extends HTMLElement {
  constructor() {
    super();

    const reviewsElement = this;
    const productType = reviewsElement.dataset.productType
      ? reviewsElement.dataset.productType
      : "General";

      let amountOffSlides = 0;

    if (window.innerWidth > 768) {
       amountOffSlides = reviewsElement.dataset.amountSlides;
    } else {
       amountOffSlides = reviewsElement.dataset.amountSlidesmobile;
    }
    const sliderElement = reviewsElement.querySelector(
      ".trustpilot-reviews__slider"
    );

    const getReviewsBasedOnProductType = async (productType) => {
      const url = `https://idyl-trustpilot-3x4ha.ondigitalocean.app/trustpilot/tag/${productType}`;
      const method = "GET";
      const config = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await axios(config);
        const data = response.data;
        return data;
      } catch (error) {
        return {
          error: error.response,
          code: 400,
        };
      }
    };

    const starIconElement = `
      <svg class="icon-star" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1881_1383)">
        <path d="M12.4977 4.87655H7.91621L6.50103 0.290527L5.08151 4.87655L0.5 4.87197L4.21036 7.70908L2.79068 12.2905L6.50103 9.45799L10.2069 12.2905L8.79171 7.70908L12.4977 4.87655Z" fill="#33302D"/>
        <path d="M9.11302 8.74625L8.79459 7.70898L6.50391 9.45789L9.11302 8.74625Z" fill="#33302D"/>
        </g>
        <defs>
        <clipPath id="clip0_1881_1383">
        <rect width="12" height="12" fill="white" transform="translate(0.5 0.290527)"/>
        </clipPath>
        </defs>
      </svg>  
    `;

    const setAllReviewsInSlider = (allReviews) => {
      const timeOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      let trustpilotLink =
        window.Shopify.routes.root + "pages/trustpilot-reviews";
      let currentLocation = window.location;
      let target = "_self";

      if (currentLocation.href.includes("trustpilot")) {
        trustpilotLink = "https://www.trustpilot.com/review/idyl.com";
        target = "_blank";
      }
      let mapCount = 0;
      const allReviewElements = allReviews.map((review) => {
        function WordCount(str) {
          return str.split(" ").length;
        }
        mapCount++;
        const wordtCount = WordCount(review.text);
        const shouldShowReadMore = wordtCount > 20;
        if (mapCount < +amountOffSlides + 1) {
          return `<div class="swiper-slide review-card">
            <div class="review-card__text-holder">
              <div class="text-holder__stars stars--${review.stars}">
                ${starIconElement}
                ${starIconElement}
                ${starIconElement}
                ${starIconElement}
                ${starIconElement}
              </div>
              <p class="text-holder__author">- ${review.author.replace(
                "Customer",
                ""
              )}</p>
            </div>
            <div class="content-holder">
              <h6 class="content-holder__title">${review.title}</h6>
              <p class="content-holder__text truncated-text">${review.text
                .split(" ")
                .slice(0, 20)
                .join(" ")}${shouldShowReadMore ? "....." : ""}</p>
              <p class="content-holder__text full-text" style="display: none;">${
                review.text
              }</p>
              ${
                shouldShowReadMore
                  ? `<a class="content-holder__link read-more">Read More</a>`
                  : ""
              }
              </div>
            <div class="review-info">
              <div class="review-info__verify verify">
                <span class="verify__text">${window.reviews.verified_by}</span>
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1929_24453)">
                    <path d="M11.9987 5.08602H7.41716L6.00198 0.5L4.58246 5.08602L0.000946045 5.08145L3.7113 7.91855L2.29163 12.5L6.00198 9.66746L9.70784 12.5L8.29266 7.91855L11.9987 5.08602Z" fill="#33302D"/>
                    <path d="M8.61128 8.95572L8.29285 7.91846L6.00217 9.66737L8.61128 8.95572Z" fill="#F8F3ED"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1929_24453">
                      <rect width="12" height="12" fill="white" transform="translate(0 0.5)"/>
                    </clipPath>
                  </defs>
                </svg>
                <a class="trustpilot verify__link" href="${trustpilotLink}" target="${target}">Trustpilot</a>
              </div>
              <div class="review-info__date date">
                <p class="date__text">${new Date(
                  review.createdAt
                ).toLocaleString(undefined, timeOptions)}</p>
              </div>
            </div>
          </div>
        `;
        }
      });

      sliderElement.innerHTML = allReviewElements.join("");

      // Add an event listener to toggle the text
      document.addEventListener("click", (event) => {
        if (event.target.classList.contains("read-more")) {
          const card = event.target.closest(".review-card");
          const truncatedText = card.querySelector(".truncated-text");
          const fullText = card.querySelector(".full-text");
          const readMore = card.querySelector(".read-more");
          if (truncatedText && fullText) {
            truncatedText.style.display = "none";
            fullText.style.display = "block";
            readMore.style.display = "none";
          }
        }
      });
    };

    // Listen for DOM Content loaded to run the async function
    document.addEventListener("DOMContentLoaded", async () => {
      const allTrustpilotReviews = await getReviewsBasedOnProductType(
        productType
      );

      // set all reviews in slider
      if (allTrustpilotReviews) {
        if (allTrustpilotReviews.code == 400) {
        } else {
          setAllReviewsInSlider(allTrustpilotReviews);

          const trustpilotSwiper =
            reviewsElement.querySelector(".swiper")?.swiper;
          trustpilotSwiper?.updateSlides();
        }
      }
    });
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("trustpilot-reviews") === undefined) {
  customElements.define("trustpilot-reviews", TrustpilotReviews);
}
